module.exports = __webpack_public_path__ + "img/dp_lp_pc_cn_copy.aa8e86e8.png";